import { Link, useLocation } from "react-router-dom";

const COPY = {
  "/about": {
    title: "About This Commentary",
    body: "Haydock's Catholic Bible Commentary is a 19th-century compilation of patristic and scholastic notes upon the Douay-Rheims Bible, edited by the Rev. Fr. George Leo Haydock (1774–1849). This revised reader preserves the original text while restoring legible typography, generous spacing, and a calm reading environment.",
  },
  "/commentators": {
    title: "Commentators",
    body: "Haydock draws upon the Fathers and Doctors of the Church, including St. Jerome, St. Augustine, St. John Chrysostom, Theophylactus, Estius, Witham, Calmet, Challoner, and many others. Each note in the commentary cites its source.",
  },
  "/notes": {
    title: "Transcriber's Notes",
    body: "The transcribed text follows the 1859 edition. Spelling, punctuation, and proper names are preserved as in the original. Cross-references and footnotes appear as they did in the printed volume.",
  },
  "/ebooks": {
    title: "Free E-Books",
    body: "Public-domain editions of the Douay-Rheims Bible and the full Haydock commentary may be downloaded freely from established Catholic archives.",
  },
  "/contact": {
    title: "Contact",
    body: "For corrections, suggestions, or questions about this revised reader, please write to the editors of quidverum.org.",
  },
};

export default function InfoPage() {
  const { pathname } = useLocation();
  const info = COPY[pathname] || {
    title: "Page",
    body: "Content forthcoming.",
  };

  return (
    <div data-testid="info-page" className="max-w-3xl mx-auto px-6 py-14">
      <div className="parchment-card p-9 md:p-12 fade-in">
        <div
          className="text-center"
          style={{
            fontFamily: "'IM Fell English SC', serif",
            letterSpacing: "0.3em",
            color: "var(--ink-muted)",
            fontSize: "0.85rem",
          }}
        >
          QUIDVERUM &middot; SCRIPTORIUM
        </div>
        <h1
          className="text-center"
          style={{
            fontSize: "clamp(2rem, 3.6vw, 2.8rem)",
            margin: "0.4rem 0 0.6rem",
          }}
        >
          {info.title}
        </h1>
        <div className="ornament mb-7" aria-hidden>
          <span>&#10086;</span>
        </div>
        <p
          style={{
            fontSize: "1.15rem",
            lineHeight: 1.75,
            color: "var(--ink-soft)",
            textAlign: "justify",
            hyphens: "auto",
          }}
          data-testid="info-body"
        >
          {info.body}
        </p>
        <div className="mt-8 text-center">
          <Link to="/" className="btn-ghost" data-testid="info-back">
            BACK TO INDEX
          </Link>
        </div>
      </div>
    </div>
  );
}
